//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy, maxBy, minBy } from 'lodash-es';
import _price from '~/utils/price';
export default {
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
    margin: {
      type: Number,
      default: 0,
    },
    defaultPlan: {
      type: Object,
      default: () => ({
        unset: {
          price: 0,
          currency: 'USD',
          interval: '',
        },
      }),
    },
  },
  computed: {
    priceSame() {
      const min = this.priceMin;
      const max = this.priceMax;
      return min.price === max.price;
    },
    priceUnset() {
      const min = this.priceMin;
      const same = this.priceSame;
      return same && min === this.defaultPlan.unset;
    },
    priceMax() {
      const plans = this.plans(this.items);
      return maxBy(plans, 'price') ?? this.defaultPlan.unset;
    },
    priceMin() {
      const plans = this.plans(this.items);
      return minBy(plans, 'price') ?? this.defaultPlan.unset;
    },
  },
  methods: {
    price(cost) {
      return _price({ cost, margin: this.margin });
    },
    plans(plans) {
      return sortBy(plans ?? this.defaultPlan, 'price');
    },
    priceRange() {
      const max = this.priceMax;
      const min = this.priceMin;
      const same = this.priceSame;
      const unset = this.priceUnset;
      return !unset
        ? `${min.price === 0 ? 'Free' : this.price(min.price)}${
            !same ? ' up to ' : ''
          }${!same ? this.price(max.price) : ''} ${min.currency ?? ''} ${
            max.interval ? '/' : ''
          } ${max.interval ?? ''}`
        : '';
    },
  },
};
